import React, {useState, useMemo, useEffect} from "react"
import { useSelector, useDispatch } from "react-redux"
import { ClickAwayListener, FormControl, Collapse } from "@mui/material"
import { useTranslation } from "react-i18next"
import { getGroupLocation } from "../../../redux/actions/admin-index"

const containsTextGroups = (group, search) => {
    const groupNameMatches = group.name.toLowerCase().indexOf(search.toLowerCase()) > -1;
  
    if (groupNameMatches) {
      return {...group};
    }
  
    const matchingLocations = group.locations.filter(location =>
      Object.values(location).some(value =>
        typeof value === 'string' && value.toLowerCase().indexOf(search.toLowerCase()) > -1
      )
    );
  
    return matchingLocations.length > 0 ? { ...group, locations: matchingLocations } : null;
};
const AllGroupLocations = ({disabled}) => {
    const dispatch = useDispatch()
    const [show, setShow] = useState(false)
    const [searchGroups, setSearchGroups] = useState("");
    const [locationsOfGroup, setLocationsOfGroup] = useState()

    const user = useSelector(state => state.getUserInfo.user)
    let groupsArray = user && user.user.groups
    const groupSelected = useSelector(state => state.groupSelected.group)   
    const location = useSelector(state => state.locationSelected.location) 
    const selected = useSelector(state => state.groupLocationSelected.group_location)
    const locations = user?.user?.locations

    useEffect(() => {
        if(groupsArray){
            setLocationsOfGroup(groupsArray)
        }
    }, [groupSelected, user])

    const {t} = useTranslation()
    const displayedGroup = useMemo(() => locationsOfGroup && locationsOfGroup.map(group => containsTextGroups(group, searchGroups)).filter(Boolean), [searchGroups, user, locationsOfGroup]);


    // useEffect(() => {
    //     if(!selected && displayedGroup){
    //         dispatch(getGroupLocation(displayedGroup[0]?.locations[0].id))
    //     }
    // }, [locationsOfGroup, groupSelected])


    useEffect(() => {
        if(!localStorage.getItem("location_of_group") && displayedGroup){
            let allLocked = locations?.every(loc => loc.is_locked)
            let onlyOneUnlocked = locations?.find(loc => !loc.is_locked)
            let selectLoc = allLocked ? displayedGroup[0]?.locations[0].id : onlyOneUnlocked?.id
            dispatch(getGroupLocation(selectLoc))
            localStorage.setItem("location_of_group", selectLoc)
        }
        if(localStorage.getItem("location_of_group")){
            dispatch(getGroupLocation(localStorage.getItem("location_of_group")))
        }
    }, [locationsOfGroup])

    const onLocationSelect = (id) => {
        dispatch(getGroupLocation(id))
        localStorage.setItem("location_of_group", id)
        setShow(false)
    }
   if(displayedGroup){
        return(
            <div className={disabled ? "disable-inner-dropdown" : ""} style={{marginTop: '6px'}}>
                <ClickAwayListener onClickAway={() => setShow(false)}>
                    <div style={{position: "relative"}}>
                        <FormControl className="select-search-loc">
                            <div onClick={() => setShow(!show)} className='select-search-header' style={{borderColor: show ? "#18AEE3" : "#EDEDED"}}>
                                {locationsOfGroup.flatMap(group => group.locations).filter(loc => loc.id == selected)[0] ? 
                                locationsOfGroup.flatMap(group => group.locations).filter(loc => loc.id == selected)[0].full_name : " "}
                            </div>
                        </FormControl>
                        <Collapse in={show}>
                            <div className='loc-group-container-wrapper'>
                                <div className="loc-group-tabs"></div>
                                <input type="text" placeholder={t("Search Location")} className='search-inside-dropdown' 
                                    onChange={(e) => setSearchGroups(e.target.value)}
                                    onKeyDown={(e) => {
                                        if(e.key !== 'Escape'){
                                            e.stopPropagation();
                                        }
                                    }}
                                />
                                <div className='loc-group-container custom-scrollbar-vertical'>
                                    {displayedGroup && displayedGroup.map(group => (
                                        <div key={`${group.id}-allgroupcontainer`}>
                                            <span style={{pointerEvents: "none"}} className="group-name-span">{t("Group")} - {group.name}</span>
                                            {
                                                    group.locations.map(loc => (
                                                    <div key={`${loc.id}-allgroup`} className="left-loc-icon element-container">
                                                        <input type="radio" name="location_of_group" value={loc.id} id={`locOfGr-${loc.id}`} checked={loc.id == selected} onChange={() => {
                                                            onLocationSelect(loc.id)
                                                        }}/>
                                                        <label htmlFor={`locOfGr-${loc.id}`}>
                                                            {loc.full_name}
                                                            {loc?.is_locked && (
                                                                <span className='locked_span' key={Math.random()}>
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="10" viewBox="0 0 8 10" fill="none">
                                                                        <path d="M6.28264 3.59968V2.44816C6.28171 1.82557 6.03398 1.22874 5.59374 0.788505C5.1535 0.348268 4.55668 0.100535 3.93409 0.0996094H3.73109C3.1085 0.100535 2.51167 0.348268 2.07144 0.788505C1.6312 1.22874 1.38347 1.82557 1.38254 2.44816V3.59968C1.10406 3.59968 0.836981 3.71031 0.640064 3.90722C0.443146 4.10414 0.33252 4.37122 0.33252 4.6497V7.90476C0.333445 8.4336 0.543933 8.94051 0.917875 9.31445C1.29182 9.68839 1.79873 9.89888 2.32756 9.8998H5.33762C5.86645 9.89888 6.37336 9.68839 6.7473 9.31445C7.12125 8.94051 7.33173 8.4336 7.33266 7.90476V4.6497C7.33266 4.37122 7.22203 4.10414 7.02512 3.90722C6.8282 3.71031 6.56112 3.59968 6.28264 3.59968ZM2.08255 2.44816C2.08255 2.01094 2.25624 1.59163 2.5654 1.28247C2.87456 0.973308 3.29387 0.799623 3.73109 0.799623H3.93409C4.37131 0.799623 4.79062 0.973308 5.09978 1.28247C5.40894 1.59163 5.58262 2.01094 5.58262 2.44816V3.59968H2.08255V2.44816ZM6.63265 7.90476C6.63265 8.24823 6.49621 8.57762 6.25334 8.82049C6.01048 9.06335 5.68108 9.19979 5.33762 9.19979H2.32756C1.9841 9.19979 1.6547 9.06335 1.41184 8.82049C1.16897 8.57762 1.03253 8.24823 1.03253 7.90476V4.6497C1.03253 4.55687 1.06941 4.46785 1.13505 4.40221C1.20069 4.33657 1.28971 4.29969 1.38254 4.29969H6.28264C6.37547 4.29969 6.46449 4.33657 6.53013 4.40221C6.59577 4.46785 6.63265 4.55687 6.63265 4.6497V7.90476Z" fill="black" />
                                                                        <path d="M4.18235 6.6539V7.80192C4.18235 7.89475 4.14547 7.98378 4.07983 8.04942C4.01419 8.11505 3.92517 8.15193 3.83234 8.15193C3.73951 8.15193 3.65049 8.11505 3.58485 8.04942C3.51921 7.98378 3.48233 7.89475 3.48233 7.80192V6.6539C3.34888 6.57685 3.24458 6.45792 3.18561 6.31555C3.12664 6.17319 3.11629 6.01534 3.15618 5.86649C3.19606 5.71765 3.28394 5.58612 3.4062 5.49231C3.52845 5.3985 3.67824 5.34766 3.83234 5.34766C3.98644 5.34766 4.13623 5.3985 4.25848 5.49231C4.38073 5.58612 4.46862 5.71765 4.5085 5.86649C4.54838 6.01534 4.53804 6.17319 4.47907 6.31555C4.4201 6.45792 4.3158 6.57685 4.18235 6.6539Z" fill="black" />
                                                                    </svg>
                                                                    LOCKED
                                                                </span>
                                                            )}
                                                        </label>
                                                    </div> 
                                                ))
                                            }
                                        </div>
                                    ))} 
                                </div>
                            </div>
                        </Collapse>
                    </div>
                </ClickAwayListener>
            </div>
        )
   }
}
export default AllGroupLocations